export const SAVE_KEYWORDS = "SAVE_KEYWORDS";
export const LOAD_KEYWORD_INTO_STORE = "LOAD_KEYWORD_INTO_STORE";
export const LOAD_COUNTIES_INTO_STORE = "LOAD_COUNTIES_INTO_STORE";
export const LOAD_REPORT_TYPES_INTO_STORE = "LOAD_REPORT_TYPES_INTO_STORE";

